import {useContext} from 'react';
import {Navigate} from 'react-router-dom';
import {AuthContext} from '../auth/use-auth';
import {ROUTES} from '.';

export const Callback = () => {
  const context = useContext(AuthContext);
  const redirect = context.redirectUrl ?? ROUTES.DASHBOARD.path;

  return <Navigate to={redirect} />;
};